import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <Container fluid className="p-0 mt-5">
      <div className="footer-col">
        <h6>&copy; 2025 Team Droplet</h6>
      </div>
    </Container>
  );
};

export default Footer;
